const prefix = "SAVED_SEARCH_";

export const PINNED_CRITERIA_ADD = prefix + "PINNED_CRITERIA_ADD";
export const PINNED_CRITERIA_REMOVE = prefix + "PINNED_CRITERIA_REMOVE";
export const PINNED_CRITERIA_GET_FAILED = prefix + "PINNED_CRITERIA_GET_FAILED";
export const PINNED_CRITERIA_GET_STARTED = prefix + "PINNED_CRITERIA_GET_STARTED";
export const PINNED_CRITERIA_GET_SUCCEEDED = prefix + "PINNED_CRITERIA_GET_SUCCEEDED";
export const PINNED_CRITERIA_INITIAL_SETUP = prefix + "PINNED_CRITERIA_INITIAL_SETUP";
export const PINNED_CRITERIA_SAVE_FAILED = prefix + "PINNED_CRITERIA_SAVE_FAILED";
export const PINNED_CRITERIA_SAVE_STARTED = prefix + "PINNED_CRITERIA_SAVE_STARTED";
export const PINNED_CRITERIA_SAVE_SUCCEEDED = prefix + "PINNED_CRITERIA_SAVE_SUCCEEDED";
export const SAVED_SEARCHES_ADD = prefix + "SAVED_SEARCHES_ADD";
export const SAVED_SEARCHES_DELETE = prefix + "SAVED_SEARCHES_DELETE";
export const SAVED_SEARCHES_GET_FAILED = prefix + "SAVED_SEARCHES_GET_FAILED";
export const SAVED_SEARCHES_GET_STARTED = prefix + "SAVED_SEARCHES_GET_STARTED";
export const SAVED_SEARCHES_GET_SUCCEEDED = prefix + "SAVED_SEARCHES_GET_SUCCEEDED";
export const SAVED_SEARCHES_MOVE_DOWN = prefix + "SAVED_SEARCHES_MOVE_DOWN";
export const SAVED_SEARCHES_MOVE_UP = prefix + "SAVED_SEARCHES_MOVE_UP";
export const SAVED_SEARCHES_PRESELECTED_FILTER = prefix + "SAVED_SEARCHES_PRESELECTED_FILTER";
export const SAVED_SEARCHES_SAVE_FAILED = prefix + "SAVED_SEARCHES_SAVE_FAILED";
export const SAVED_SEARCHES_SAVE_STARTED = prefix + "SAVED_SEARCHES_SAVE_STARTED";
export const SAVED_SEARCHES_SAVE_SUCCEEDED = prefix + "SAVED_SEARCHES_SAVE_SUCCEEDED";
export const STATE_RESET = prefix + "STATE_RESET";
